import {nullable} from '@raison/io-ts-tools';
import {HttpClient, HttpClient$, POST, expectEither, useHttpClient} from '@raison/network-facade';
import {UseMutationOptions, useMutation} from '@tanstack/react-query';
import {TypeOf, string, type} from 'io-ts';
import {atom} from 'jotai';

export const StripeIntentSchema = type({
    client_secret: string,
    payment_intent: nullable(string),
    payment_method: nullable(string),
});
export type StripeIntentSchema = TypeOf<typeof StripeIntentSchema>;

export const addNewCardAtom = atom(get => () => {
    const http = get(HttpClient$);
    return addNewCard(http);
});

export const addNewCard = (http: HttpClient) => {
    return http('v1/cards/payments/stripe', POST()).then(
        ...expectEither({
            200: StripeIntentSchema,
        })
    );
};

export function useAddNewCard(options?: Omit<UseMutationOptions, 'mutationKey' | 'mutationFn'>) {
    const http = useHttpClient();
    return useMutation({
        mutationKey: ['v1/cards/payments/stripe'],
        async mutationFn() {
            const response = await addNewCard(http);
            if (response.status === 'Abort') {
                throw response.reason;
            }
            return response.json;
        },
        ...options,
    });
}
